var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "admin-linear-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.storeRole.apply(null, arguments)
        },
        keydown: function ($event) {
          return _vm.roleForm.errors.clear($event.target.name)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "admin-linear-field" },
        [
          _c("label", [_vm._v(_vm._s(_vm.trans("role.name")))]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.roleForm.name,
                expression: "roleForm.name",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              value: "",
              name: "name",
              placeholder: _vm.trans("role.name"),
            },
            domProps: { value: _vm.roleForm.name },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.roleForm, "name", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("show-error", {
            attrs: { "form-name": _vm.roleForm, "prop-name": "name" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "admin-linear-form__actions" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-sm admin-form-btn-cancel",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("cancel")
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("general.cancel")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
            attrs: { type: "submit" },
          },
          [_c("span", [_vm._v(_vm._s(_vm.trans("general.save")))])]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }